import { Skeleton } from "@mui/material";
import { ImageWrapperProps } from "../../interfaces/props/ImageWrapperProps";
import classes from './ImageWrapper.module.scss';
import useImageValidator from "../../hooks/useImageValidator";

const ImageWrapper = ({ src, alt, fallbackElement, className }: ImageWrapperProps) => {
  const { isValid, isLoading } = useImageValidator(src);

  if (isLoading) {
    return <Skeleton className={classes['loading-skeleton']} variant='rectangular' />;
  }

  if (!isValid) {
    return fallbackElement;
  }

  return <img src={src} loading='lazy' alt={alt} className={className} />;
};

export default ImageWrapper;
